export default __webpack_public_path__ + "static/media/money-send.fece348b.svg";